import { parsePhoneNumberFromString } from 'libphonenumber-js'

/**
 * Functions for form field manipulators.
 * Manipulator function will receives field value as first param and change event as second
 * and it should return field value, manipulated or not.
 */

export const maxLength = (len) => {
    return (value) => {
        return value.substr(0, len)
    }
}

export const toUpperCase = (value) => {
    return value ? value.toUpperCase() : ''
}

export const parseAdIdFromUrl = (value) => {
    const temp = value.trim().toLowerCase()
    if (temp.indexOf('www.') !== -1 || temp.indexOf('http') === 0) {
        // try to find ad id of len 7 or 8 from url
        // example url:
        // https://nettiauto.almaajo.dev/audi/50/11758513?someparameters=11758513
        const res = value.match(/.*\/.*\/.*\/(\b\d{7,8}\b)/)
        return res && res.length > 0 ? res[1] : value
    }

    return value
}

export const decimalCommaToPoint = (value) => {
    return value ? value.replace(/,/g, '.') : value
}

export const trimLeadingZeros = (value) => {
    return value !== '0' ? value.replace(/^0+/, '') : value
}

export const addFractionDigitsToEuros = (value) => {
    const cents = convertEurosToCents(value)

    return convertCentsToEuros(cents)
}

export const convertCentsToEuros = (value) => {
    if (!value) {
        return '0.00'
    }

    const number = typeof value === 'number' ? `${value}` : value

    if (number.length === 1) {
        return `0.0${number}`
    } else if (number.length === 2) {
        return `0.${number}`
    }

    const euros = number.substring(0, number.length - 2)
    const cents = number.substring(number.length - 2, number.length)

    return `${euros}.${cents}`
}

export const convertEurosToCents = (value) => {
    if (!value) {
        return 0
    }

    if (typeof value === 'number') {
        return value * 100
    }

    const valueWithPoint = decimalCommaToPoint(value)
    const splitted = valueWithPoint.split('.')

    if (!(splitted.length === 1 || splitted.length === 2)) {
        return value
    }

    let euros
    let cents = '00'

    if (splitted.length === 1) {
        euros = splitted[0]
    } else if (splitted.length === 2) {
        euros = splitted[0]
        cents = splitted[1]
    }

    if (cents.length === 1) {
        cents = cents.padEnd(2, '0')
    }

    return parseInt(`${euros}${cents}`)
}

export const roundNumberFieldTo = (numDecimals = 2) => {
    return (value) => {
        const parts = value.split('.')
        if (parts.length >= 2 && parts[1].length > numDecimals) {
            const decimals = parts[1].length > 2 ? parts[1].substr(0, numDecimals) : parts[1]
            return `${parts[0]}.${decimals}`
        } else {
            return value
        }
    }
}

export const numberize = (value) => {
    return value ? parseFloat(value) : ''
}

export const formatPhoneNumber = (value) => {
    const obj = parsePhoneNumberFromString(value, 'FI')
    return obj ? obj.number : ''
}
